/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { FacadeStatLib, FacadeStatLibInterface } from "../FacadeStatLib";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "OutOfBounds",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256",
      },
    ],
    name: "TooLowX",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
    ],
    name: "UnknownHeroClass",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "dexterity",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
    ],
    name: "attackRating",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32[]",
        name: "base",
        type: "int32[]",
      },
      {
        internalType: "int32[]",
        name: "add",
        type: "int32[]",
      },
    ],
    name: "attributesAdd",
    outputs: [
      {
        internalType: "int32[]",
        name: "",
        type: "int32[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "attributes_",
        type: "bytes32[]",
      },
    ],
    name: "bytesToFullAttributesArray",
    outputs: [
      {
        internalType: "int32[]",
        name: "result",
        type: "int32[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "attackersAttackRating",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "defendersDefenceRating",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "attackersLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "defendersLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "arFactor",
        type: "uint256",
      },
    ],
    name: "chanceToHit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "dexterity",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
    ],
    name: "defense",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "monsterExp",
        type: "uint32",
      },
      {
        internalType: "uint256",
        name: "monsterRarity",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "heroExp",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "heroCurrentLvl",
        type: "uint32",
      },
      {
        internalType: "uint256",
        name: "monsterBiome",
        type: "uint256",
      },
    ],
    name: "expPerMonster",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "experience",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "startFromLevel",
        type: "uint256",
      },
    ],
    name: "experienceToLvl",
    outputs: [
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "heroCurrentExp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "heroCurrentLevel",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "withGap",
        type: "bool",
      },
    ],
    name: "getVirtualLevel",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "attributes",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "level",
        type: "uint32",
      },
      {
        components: [
          {
            internalType: "int32",
            name: "strength",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "dexterity",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "vitality",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "energy",
            type: "int32",
          },
        ],
        internalType: "struct IStatController.CoreAttributes",
        name: "base",
        type: "tuple",
      },
    ],
    name: "initAttributes",
    outputs: [
      {
        internalType: "uint32[]",
        name: "result",
        type: "uint32[]",
      },
      {
        internalType: "bytes32[]",
        name: "attributesOut",
        type: "bytes32[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
    ],
    name: "initialHero",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int32",
                name: "strength",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "dexterity",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "vitality",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "energy",
                type: "int32",
              },
            ],
            internalType: "struct IStatController.CoreAttributes",
            name: "core",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "minDamage",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxDamage",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "attackRating",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "defense",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "blockRating",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "life",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "mana",
                type: "uint256",
              },
            ],
            internalType: "struct StatLib.BaseMultiplier",
            name: "multiplier",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "life",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "mana",
                type: "uint256",
              },
            ],
            internalType: "struct StatLib.LevelUp",
            name: "levelUp",
            type: "tuple",
          },
          {
            internalType: "int32",
            name: "baseLifeChances",
            type: "int32",
          },
        ],
        internalType: "struct StatLib.InitialHero",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initialHero1",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int32",
                name: "strength",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "dexterity",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "vitality",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "energy",
                type: "int32",
              },
            ],
            internalType: "struct IStatController.CoreAttributes",
            name: "core",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "minDamage",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxDamage",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "attackRating",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "defense",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "blockRating",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "life",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "mana",
                type: "uint256",
              },
            ],
            internalType: "struct StatLib.BaseMultiplier",
            name: "multiplier",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "life",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "mana",
                type: "uint256",
              },
            ],
            internalType: "struct StatLib.LevelUp",
            name: "levelUp",
            type: "tuple",
          },
          {
            internalType: "int32",
            name: "baseLifeChances",
            type: "int32",
          },
        ],
        internalType: "struct StatLib.InitialHero",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "initialHero2",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int32",
                name: "strength",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "dexterity",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "vitality",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "energy",
                type: "int32",
              },
            ],
            internalType: "struct IStatController.CoreAttributes",
            name: "core",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "minDamage",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxDamage",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "attackRating",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "defense",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "blockRating",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "life",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "mana",
                type: "uint256",
              },
            ],
            internalType: "struct StatLib.BaseMultiplier",
            name: "multiplier",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "life",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "mana",
                type: "uint256",
              },
            ],
            internalType: "struct StatLib.LevelUp",
            name: "levelUp",
            type: "tuple",
          },
          {
            internalType: "int32",
            name: "baseLifeChances",
            type: "int32",
          },
        ],
        internalType: "struct StatLib.InitialHero",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initialHero3",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int32",
                name: "strength",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "dexterity",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "vitality",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "energy",
                type: "int32",
              },
            ],
            internalType: "struct IStatController.CoreAttributes",
            name: "core",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "minDamage",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxDamage",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "attackRating",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "defense",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "blockRating",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "life",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "mana",
                type: "uint256",
              },
            ],
            internalType: "struct StatLib.BaseMultiplier",
            name: "multiplier",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "life",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "mana",
                type: "uint256",
              },
            ],
            internalType: "struct StatLib.LevelUp",
            name: "levelUp",
            type: "tuple",
          },
          {
            internalType: "int32",
            name: "baseLifeChances",
            type: "int32",
          },
        ],
        internalType: "struct StatLib.InitialHero",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "initialHero4",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int32",
                name: "strength",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "dexterity",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "vitality",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "energy",
                type: "int32",
              },
            ],
            internalType: "struct IStatController.CoreAttributes",
            name: "core",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "minDamage",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxDamage",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "attackRating",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "defense",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "blockRating",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "life",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "mana",
                type: "uint256",
              },
            ],
            internalType: "struct StatLib.BaseMultiplier",
            name: "multiplier",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "life",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "mana",
                type: "uint256",
              },
            ],
            internalType: "struct StatLib.LevelUp",
            name: "levelUp",
            type: "tuple",
          },
          {
            internalType: "int32",
            name: "baseLifeChances",
            type: "int32",
          },
        ],
        internalType: "struct StatLib.InitialHero",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "initialHero5",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int32",
                name: "strength",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "dexterity",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "vitality",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "energy",
                type: "int32",
              },
            ],
            internalType: "struct IStatController.CoreAttributes",
            name: "core",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "minDamage",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxDamage",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "attackRating",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "defense",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "blockRating",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "life",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "mana",
                type: "uint256",
              },
            ],
            internalType: "struct StatLib.BaseMultiplier",
            name: "multiplier",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "life",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "mana",
                type: "uint256",
              },
            ],
            internalType: "struct StatLib.LevelUp",
            name: "levelUp",
            type: "tuple",
          },
          {
            internalType: "int32",
            name: "baseLifeChances",
            type: "int32",
          },
        ],
        internalType: "struct StatLib.InitialHero",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "level",
        type: "uint32",
      },
    ],
    name: "levelExperience",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "vitality",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "level",
        type: "uint32",
      },
    ],
    name: "life",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "level",
        type: "uint32",
      },
    ],
    name: "lifeChances",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "energy",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "level",
        type: "uint32",
      },
    ],
    name: "mana",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "strength",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
    ],
    name: "maxDamage",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "strength",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
    ],
    name: "minDamage",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "experience",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "startFromLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "monsterBiome",
        type: "uint256",
      },
    ],
    name: "mintDropChanceDelta",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "level",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "experience",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "life",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "mana",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "lifeChances",
            type: "uint32",
          },
        ],
        internalType: "struct IStatController.ChangeableStats",
        name: "stats",
        type: "tuple",
      },
    ],
    name: "packChangeableStats",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackChangeableStats",
    outputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "level",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "experience",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "life",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "mana",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "lifeChances",
            type: "uint32",
          },
        ],
        internalType: "struct IStatController.ChangeableStats",
        name: "result",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IController",
        name: "controller",
        type: "address",
      },
      {
        internalType: "bytes32[]",
        name: "attributes",
        type: "bytes32[]",
      },
      {
        internalType: "bytes32[]",
        name: "bonusMain",
        type: "bytes32[]",
      },
      {
        internalType: "bytes32[]",
        name: "bonusExtra",
        type: "bytes32[]",
      },
      {
        components: [
          {
            internalType: "uint32",
            name: "level",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "experience",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "life",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "mana",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "lifeChances",
            type: "uint32",
          },
        ],
        internalType: "struct IStatController.ChangeableStats",
        name: "heroStats",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        internalType: "int32",
        name: "base",
        type: "int32",
      },
    ],
    name: "updateCoreDependAttributes",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "attributesOut",
        type: "bytes32[]",
      },
      {
        internalType: "bytes32[]",
        name: "bonusMainOut",
        type: "bytes32[]",
      },
      {
        internalType: "bytes32[]",
        name: "bonusExtraOut",
        type: "bytes32[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32[]",
        name: "attributes",
        type: "int32[]",
      },
      {
        internalType: "int32[]",
        name: "bonus",
        type: "int32[]",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "level",
        type: "uint32",
      },
    ],
    name: "updateCoreDependAttributesInMemory",
    outputs: [
      {
        internalType: "int32[]",
        name: "",
        type: "int32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32[]",
        name: "values",
        type: "int32[]",
      },
      {
        internalType: "uint8[]",
        name: "ids",
        type: "uint8[]",
      },
    ],
    name: "valuesToFullAttributesArray",
    outputs: [
      {
        internalType: "int32[]",
        name: "result",
        type: "int32[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
] as const;

export class FacadeStatLib__factory {
  static readonly abi = _abi;
  static createInterface(): FacadeStatLibInterface {
    return new Interface(_abi) as FacadeStatLibInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): FacadeStatLib {
    return new Contract(address, _abi, runner) as unknown as FacadeStatLib;
  }
}
